// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Report } from './report';
import { ReportCategory } from './report-category';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReportReportCategory extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  reportId!: number;
  reportCategoryId!: number;
  ts!: string;
  report!: Report;
  reportCategory!: ReportCategory;
}

